export enum ShowRankingOrganizationFeatureState {
    On = 'on',
    OnlyPoints  = 'onlyPoints ',
    Off = 'off'
}
